import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-drawer',
  templateUrl: './terms-drawer.component.html',
  styleUrls: ['./terms-drawer.component.scss']
})
export class TermsDrawerComponent implements OnInit {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  previewDoc: any = null;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() { }

  close() {
    this.previewDoc = null;
    this.closed.emit();
  }

  viewDoc(doc: any) {
    this.previewDoc = doc;
  }

  closePreview() {
    this.previewDoc = null;
  }

  downloadDoc(doc: any) {
    if (doc.url) {
      const a = document.createElement('a');
      a.href = doc.url;
      a.download = doc.name || 'document';
      a.click();
    }
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

    getFileIcon(doc: any): string {
    const name: string = doc.name || '';
    const ext = (doc.extension || (name.includes('.') ? name.split('.').pop() : '') || '').toLowerCase();
    switch (ext) {
      case 'pdf': return 'picture_as_pdf';
      case 'xls':
      case 'xlsx':
      case 'csv': return 'grid_on';
      case 'doc':
      case 'docx': return 'article';
      case 'ppt':
      case 'pptx': return 'slideshow';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif': return 'image';
      case 'zip':
      case 'rar': return 'folder_zip';
      default: return 'insert_drive_file';
    }
  }
    getIconColor(doc: any): string {
    const name: string = doc.name || '';
    const ext = (doc.extension || (name.includes('.') ? name.split('.').pop() : '') || '').toLowerCase();
    switch (ext) {
      case 'pdf': return 'text-red-500';
      case 'xls':
      case 'xlsx':
      case 'csv': return 'text-green-500';
      case 'doc':
      case 'docx': return 'text-blue-500';
      case 'ppt':
      case 'pptx': return 'text-orange-500';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif': return 'text-purple-500';
      case 'zip':
      case 'rar': return 'text-yellow-600';
      default: return 'text-gray-500';
    }
  }
}
